(function tagManager(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Modules = global.NewHomeSource.Modules || {};

  const previousTagManager = global.NewHomeSource.tagManager;

  const id = document.documentElement.lang === 'en' ? 'GTM-9SD7' : 'GTM-KWLWXZ';

  const gtmObject = {
    value: global.google_tag_manager && global.google_tag_manager[id],
    get getValue() {
      this.value = this.value || (global.google_tag_manager && global.google_tag_manager[id]);
      return this.value;
    }
  };

  /**
   * @constructs NewHomeSource.Modules.tagManager
   */
  function TagManager() {
  }

  /**
   * @public
   * getFromDataLayer: queries the Google Tag Manager data layer and returns the value associated.
   *
   * @param {string} attribute name of the value being queried.
   */
  TagManager.getFromDataLayer = function getFromDataLayer(attribute) {
    return gtmObject.getValue && gtmObject.value.dataLayer.get(attribute);
  };

  /**
   * @public
   * setDataLayerValue: sets the dataLayer value you are providing.
   *
   * @param {string} attribute name of the value being set.
   * @param {string} value to be set.
   */
  TagManager.setDataLayerValue = function setDataLayerValue(attribute, value) {
    if (gtmObject.getValue) {
      gtmObject.value.dataLayer.set(attribute, value);
    }
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.Modules.tagManager to the previous script.
   */
  TagManager.noConflict = function noConflict() {
    global.NewHomeSource.Modules.tagManager = previousTagManager;
    return TagManager;
  };

  global.NewHomeSource.Modules.tagManager = TagManager;
}(window));
